exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wix-style-sample{padding:1px;height:-webkit-fill-available;height:-moz-available;height:stretch}.wix-style-sample h3,.wix-style-sample p{margin:0;padding:0}.wix-style-sample .sample-element{margin:5px 0}.wix-style-sample .sample-element{margin:5px 0}.wix-style-sample .sample-button{padding:10px 15px;border:0;width:100%}.wix-style-sample .sample-input{padding:10px 15px;border:1px solid black;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.wix-style-sample .form{display:block;margin-top:10px}.wix-style-sample .hiddenBox{display:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/widget/widget.scss
// module id = 466
// module chunks = 0 1